import { GetterTree } from 'vuex';
import { ClipboardState } from './state';

export const getters: GetterTree<ClipboardState, any> = {
  getClipboard: (state) => state.clipboardValues,
};
